export default "__VITE_ASSET__B_D0QpgN__"